import OverviewCard from 'components/dashboard/OverviewCard';
import React from 'react';
import { connect } from 'react-redux';

const EVENTS_DATA_LIST_CONFIG = [
  {
    title: 'Total number of published event',
    key: 'totalNumberOfPublishedEvents',
  },
  {
    title: 'Total number of event conversion',
    key: 'totalNumberOfEventConversions',
  },
  {
    title: 'Total number of event view',
    key: 'totalNumberOfEventViews',
  },
  {
    title: 'Event conversion rate',
    key: 'eventCampaignConversionRate',
    showPercentage: true,
  },
  {
    title: 'Event share rate',
    key: 'eventShareRate',
    showPercentage: true,
  },
];

const TICKET_DATA_LIST_CONFIG = [
  {
    title: 'Total number of ticket activity',
    key: 'totalNumberOfTicketActivities',
  },
  {
    title: 'Ticket used',
    key: 'totalNumberOfTicketsUsed',
  },
];

const EventsOverviewTab = ({
  eventsOverviewData
}) => {
  return (
    <div>
      <div className="overview-row-title overview-campaigns-title">
        {"Events"}
      </div>
      <div className="overview-row">
        {EVENTS_DATA_LIST_CONFIG.map((config, index) => (
          <OverviewCard
            title={config.title}
            value={eventsOverviewData?.[config.key]?.value}
            change={eventsOverviewData?.[config.key]?.change}
            showPercentage={config.showPercentage}
          />
        ))}
      </div>

      <div className="overview-row-title">
        {"Tickets"}
      </div>
      <div className="overview-row">
        {TICKET_DATA_LIST_CONFIG.map((config, index) => (
          <OverviewCard
            title={config.title}
            value={eventsOverviewData?.[config.key]?.value}
            change={eventsOverviewData?.[config.key]?.change}
          />
        ))}
      </div>
    </div>
  );
};

const mapPropsToState = (state) => ({
  eventsOverviewData: state.overview.events
});
export default connect(mapPropsToState)(EventsOverviewTab);
